export default __webpack_public_path__ + "static/media/Armguards of the Black Warden.391faba2.jpg";